import { render, staticRenderFns } from "./Modal-Dialog.vue?vue&type=template&id=38d78832&lang=pug"
import script from "./Modal-Dialog.vue?vue&type=script&lang=ts"
export * from "./Modal-Dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports